/***
 * !!! В попапах используется CommonEditFormSubmitWidgetComponent
 * Является простой оберткой над кнопкой submit и регистрируется в форме
 * Нужен в формах с валидацией в режиме submit
 */
import {
	Component,
	Input,
	ChangeDetectionStrategy,
	forwardRef,
} from '@angular/core';
import {
	NG_VALUE_ACCESSOR,
	ControlValueAccessor,
} from '@angular/forms';

@Component({
	selector: 'common-submit-button',
	templateUrl: './submit_button.component.pug',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		multi: true,
		useExisting: forwardRef(() => CommonSubmitButtonComponent),
	}],
})
// компонент зарегистрирован как контрол для того чтобы можно было понять в каком режиме включать валидацию формы
export class CommonSubmitButtonComponent implements ControlValueAccessor {
	@Input() isDisabled = false;
	@Input() ctrlClasses = '';
	@Input() withoutBtnClasses: boolean;

	model: any = null;

	writeValue (value: any): void {
		this.model = value;
	}

	registerOnChange (): void {
		//
	}

	registerOnTouched (): void {
		//
	}
}
